export enum BidStatus {
  Cancelled = 'CANCELLED',
  Accepted = 'ACCEPTED',
  Pending = 'PENDING',
  Rejected = 'REJECTED',
}
